import { useState } from 'react';

export default function ToggleShowVal({ children, initial }) {
  const [show, setShow] = useState(initial);

  return (
    <div className="flex items-center">
      <button
        className="py-1 px-2 border rounded mr-2 hover:bg-gray-100"
        onClick={() => setShow((prevState) => !prevState)}
      >
        {show ? 'Hide' : 'Show'}
      </button>
      {show && children}
    </div>
  );
}
